import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { TextArea } from '@zocdoc-frontend-common/components-textarea';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

export class DoctorNotesView extends React.Component {
    static propTypes = {
        doctorNotes: PropTypes.string,
        onEnterDoctorNotes: PropTypes.func.isRequired,
        trackSelectDoctorNotes: PropTypes.func.isRequired,
    };

    static defaultProps = {
        doctorNotes: '',
    };

    handleChangeTextArea = ev => {
        const { onEnterDoctorNotes } = this.props;
        return onEnterDoctorNotes(ev.target.value);
    };

    render() {
        const { doctorNotes, trackSelectDoctorNotes } = this.props;

        return (
            <FormRow>
                <Header data-test="doctor-notes-header">
                    <Label>Notes for the doctor's office</Label>{' '}
                    <OptionalText>(optional)</OptionalText>
                </Header>

                <TextArea
                    className="exclude-from-playback"
                    data-test="doctor-notes-text-area"
                    fluid
                    onChange={this.handleChangeTextArea}
                    onFocus={trackSelectDoctorNotes}
                    value={doctorNotes}
                />
            </FormRow>
        );
    }
}

const BaseHeaderText = css`
    font-size: 15px;
    line-height: 24px;
`;

const Header = styled.div`
    margin-bottom: 4px;
`;

const Label = styled.span`
    ${BaseHeaderText}
    font-family: ${FontFamily.SharpSansSemibold};
`;

const OptionalText = styled.span`
    ${BaseHeaderText}
    font-family: ${FontFamily.SharpSansMedium};
`;
